// @ts-ignore
import CryptoJS from "crypto-js";
import {getMiniType } from './mimeType'

export function urlToFile(url: string, filename: string) {
  return fetch(url)
    .then((res) => res.blob())
    .then((blob) => {
      return new File([blob], filename, { type: blob.type });
    });
}

export function newUrlToFile(url: string, filename: string) {
  return fetch(url)
    .then((res) => res.blob())
    .then((blob) => {
      let suffix: any = getFileSuffix(filename);
      console.log(suffix, "suffix");
      let type = getMiniType(suffix);
      console.log(type, "type");
      if (!type) {
        return {
          success: false,
          msg: "文件类型不支持！",
        };
      }
      return {
        success: true,
        file: new File([blob], filename, { type: type }),
      };
    })
    .catch((err) => {
      console.log(err, "文件下载失败！");
      return {
        success: false,
        msg: "文件下载失败！",
      };
    });
}

export function debounceFun(fn: any, delay = 500) {
  let timer: any = null;
  return function (this: any, ...args: any[]) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}
export function fileToBase64(file: File): Promise<any> {
  // let fileBase64 = ''
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    // 文件读取完成时触发load事件
    reader.onload = function (e: any) {
      resolve(e.currentTarget.result);
    };
    // 以DataURL的形式读取文件内容
    reader.readAsDataURL(file);
  });
}

export function getFileMD5(file: File): string {
  return CryptoJS.MD5(file.name + file.size).toString();
}

export function getFileSuffix(fileName: any) {
  if (!fileName) {
    return null;
  }
  const fileSuffix = fileName.split(".").pop().toLowerCase();
  return fileSuffix;
}

export function urlToBold(url: string) {
  return fetch(url)
    .then((res) => res.blob())
    .then((blob) => {
      return {
        success: true,
        blob: blob,
      };
    })
    .catch((err) => {
      console.log(err, "文件下载失败！");
      return {
        success: false,
        msg: "文件下载失败！",
      };
    });
}
